type Props = {
  skipArtFile?: boolean;
};

export const useSkipArtworkUploadFile = (props: Props) => {
  const { skipArtFile } = props;
  return Boolean(skipArtFile);
};
